import { render, staticRenderFns } from "./DashboardPromotion.vue?vue&type=template&id=bbb88e04&scoped=true"
import script from "./DashboardPromotion.vue?vue&type=script&lang=js"
export * from "./DashboardPromotion.vue?vue&type=script&lang=js"
import style0 from "./DashboardPromotion.vue?vue&type=style&index=0&id=bbb88e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb88e04",
  null
  
)

export default component.exports